//DefaultTable

import * as React from 'react';
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import InventoryIcon from '@mui/icons-material/Inventory';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import EventIcon from '@mui/icons-material/Event';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'fake_Id';

export default function BLs_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: 'estado',
            sort: 'desc',
        },
    ]);
    const intl = useIntl();
    const navigate = useNavigate();
    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
        },
        {
            field: 'destino',
            headerName: intl.formatMessage({ id: 'Destino' }),
            editable: false,
            width: 120,
        },
        {
            field: 'bl',
            headerName: intl.formatMessage({ id: 'BL' }),
            editable: false,
            width: 220,
        },
        {
            field: 'contenedores',
            headerName: intl.formatMessage({ id: 'Contenedores' }),
            editable: false,
            flex: 100,
        },
        {
            field: 'cajas',
            headerName: intl.formatMessage({ id: 'Cajas' }),
            editable: false,
            width: 80,
        },
        {
            field: 'paletizados',
            headerName: intl.formatMessage({ id: 'Paletas' }),
            editable: false,
            width: 80,
        },
        {
            field: 'pesoBruto',
            headerName: intl.formatMessage({ id: 'PesoBruto' }),
            editable: false,
            width: 80,
            renderCell: (params) => {
                const value = params.row['pesoBruto'];
                return value != null ? value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0';
            },
        },
        {
            field: 'pesoNeto',
            headerName: intl.formatMessage({ id: 'PesoNeto' }),
            editable: false,
            width: 80,
            renderCell: (params) => {
                const value = params.row['pesoNeto'];
                return value != null ? value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0';
            },
        },
        //{
        //    field: 'pesoTara',
        //    headerName: intl.formatMessage({ id: 'PesoTara' }),
        //    editable: false,
        //    width: 80,
        //    renderCell: (params) => {
        //        const value = params.row['pesoTara'];
        //        return value != null ? value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0';
        //    },
        //},
        {
            field: 'vgm',
            headerName: intl.formatMessage({ id: 'VGM' }),
            editable: false,
            width: 120,
            renderCell: (params) => {
                const value = params.row['vgm'];
                return value != null ? value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0';
            },
        },
        

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        fake_Id: false
    });
    return (
        <div>
            {/*<Toolbar>*/}
            {/*    <div className="row" style={{ width: '100%' }}>*/}
            {/*        <div className="col">*/}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*</Toolbar>*/}
            <Box sx={{
                height: 400, width: '100%',
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500, placeholder: 'Buscar' },
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: false },
                        },
                    }}
                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
